var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.field)?_c(_vm.field.component,{ref:_vm.field.id,tag:"component",attrs:{"id":_vm.field.id,"props":_vm.field},on:{"update":_vm.update}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }